import {Injectable} from '@angular/core';

import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class TransferRequestService {
    private api_url_get_warehouses = './api/switch_site/server.php?cmd=GET_WAREHOUSE_WITHOUT';
    private api_url_add_to_pannier_transfert = './api/server_tmp.php?cmd=INIT_TRANSFER_SESSION_DETAILS';
    private api_url_load_session_transfer = './api/server_tmp.php?cmd=GET_TRANSFER_SESSION';
    private api_url_validate_edition_session_transfer = './api/server_tmp.php?cmd=VALIDATE_EDITION_SESSION_TRANSFER';
    private api_url_edit_line_session_tranfer = "./api/server_tmp.php?cmd=EDIT_LINE_SESSION_TRANSFER";
    private api_url_remove_line_session_transfer = './api/server_tmp.php?cmd=REMOVE_LINE_SESSION_TRANSFER';
    private api_url_validate_session_transfer = './api/server_tmp.php?cmd=VALIDATE_SESSION_TRANSFER';

    constructor(private http: Http) {}

    GetWarehouses(): Promise<Object> {
        return this.http.get(this.api_url_get_warehouses)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    AddtoPannier(prod: any): Promise<Object> {
        return this.http.get(this.api_url_add_to_pannier_transfert
            + '&name=' + prod.name
            + '&stock=' + prod.stock
            + '&stock_virtuel=' + prod.virtual_stock
            + '&stock_disponible=' + prod.available_stock
            + '&id_article=' + prod.id_article
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    RemoveFromPanier(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_remove_line_session_transfer
            + '&id_article=' + id_article
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    LoadSessionTransfer(): Promise<Object> {
        return this.http.get(this.api_url_load_session_transfer)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidateEditionSessionTransfer(item: any): Promise<Object> {
        return this.http.get(this.api_url_validate_edition_session_transfer
            + '&id_article=' + item.id_article
            + '&quantity=' + item.quantity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditLineSessionTransfer(id_article: number): Promise<Object> {
        return this.http.get(this.api_url_edit_line_session_tranfer
            + '&id_article=' + id_article
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    ValidatePanierTransfer(name: string, remark: string, reference: string, date: any): Promise<Object> {
        return this.http.get(this.api_url_validate_session_transfer
            + '&transaction_name=' + name
            + '&remark=' + remark
            + '&reference=' + reference
            + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/transfer-request.service.ts